import React from "react"
import styled from "styled-components"
import SurveyResponseSection from "./SurveyResponseSection"
import PersonasSection from "./PersonasSection"
import Container from "../components/Container"
import Header from "../components/BigHeader"
import SubHeader from "../components/SubHeader"
import P from "../components/P"

const SurveyNumber = styled.p`
  margin-top: 25px;
  font-size: 42px;
  margin-bottom: 20px;
`

const H4 = styled.p`
  font-size: 22px;
  line-height: normal;
`
const H5 = styled.p`
  font-size: 22px;
  margin-left: 10px;
  line-height: normal;
`

const TitleContainer = styled.div`
  display: flex;
  align-items: baseline;
`

class NeedFindingSection extends React.Component {
  render() {
    return (
      <>
        <Container>
          <Header>Users Insight</Header>
          <P>
            Offering new version of Degree Planner required getting information
            from current students. Before start building the interface, it was
            important to understand what the student's needs are.
          </P>
          <SubHeader>Surveys</SubHeader>
          <P>
            We conducted a campus-wide survey to gather the needs of the
            students; Asking about their needs and the shortcomings of the
            current solutions. We’ve got:
          </P>
          <SurveyNumber>46</SurveyNumber>
          <H4>Survey responses</H4>
        </Container>
        <SurveyResponseSection />
        <Container noTop>
          <SurveyNumber>87%</SurveyNumber>
          <H4>
            said the longest part of making a degree plan was trying to know if
            their plan satisfies their declared majors
          </H4>
        </Container>
        <Container noTop>
          <SurveyNumber>73%</SurveyNumber>
          <H4>
            wished if there was a way to know when a course is offered within
            the Degree Planner
          </H4>
        </Container>
        <PersonasSection />
      </>
    )
  }
}

export default NeedFindingSection
